// extracted by mini-css-extract-plugin
module.exports = {"root":"CustomTip_root__1Oo7n","inputWrap":"CustomTip_inputWrap__1mAU_"};